import { usePhieuThuContext } from './search-context';
import { usePhieuThuMutation } from './usePhieuThuMutation';
import { usePhieuThuTable } from './usePhieuThuTable';

export const usePhieuThuPage = () => {
  const { isExporting, searchFieldState } = usePhieuThuContext();
  const tableState = usePhieuThuTable();
  const mutationState = usePhieuThuMutation({
    formMode: tableState.form.formMode,
    selectedObj: tableState.selection.selectedObj,
    addItem: tableState.crud.addItem,
    updateItem: tableState.crud.updateItem,
    deleteItem: tableState.crud.deleteItem,
    handleCloseForm: tableState.form.handleCloseForm,
    clearSelection: tableState.selection.clearSelection,
    refreshData: tableState.crud.refreshData
  });

  return {
    searchDialog: {
      ...tableState.searchDialog,
      searchFieldState
    },
    formDialog: {
      open: tableState.form.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.form.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit
    },
    multipleFormDialog: tableState.multipleFormDialog,
    deleteDialog: {
      open: tableState.form.showDelete,
      onClose: tableState.form.handleCloseDelete,
      selectedObj: tableState.selection.selectedObj,
      onDelete: tableState.crud.deleteItem,
      clearSelection: tableState.selection.clearSelection
    },
    bulkDeleteDialog: {
      open: tableState.form.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleDelete
    },
    table: tableState.table,
    detailTable: tableState.detailTable,
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleViewClick: tableState.form.handleViewClick,
      handleSearch: tableState.searchDialog.onOpen,
      handleRefresh: tableState.table.onRefresh
    },
    selection: tableState.selection
  };
};
